import { useEffect, useState } from "react";
import { Divider, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { extensionArray } from "../../../../../../../utils/extensions";
import { planApiKeyStore } from "../../../../../../../api/plan-api-key-store";
import FormInput from "../../../../../../query-builder/hooks-form-querybuilder/form-input.component";
import { FormSelectDynamic } from "../../../../../../../components/hook-form/form-select.dynamic.component";
import { FileUploadTextfield } from "../../../../../../../components/hook-form/file-upload-textfield.component";
import { FormAutoCompleteSelectDynamic } from "../../../../../../query-builder/hooks-form-querybuilder/form-autocomplete-select.dynamic.component";

interface PlanRequestArgs {
    customerID?: number;
    projectID?: number;
    officeID?: number;
    unitID?: number;
}

interface CreatePlanForm {
    isEdit: boolean;
    uploadFile: (file: File) => void;
    planRequestArgs?: PlanRequestArgs;
}

export const CreatePlanForm = ({ isEdit, uploadFile, planRequestArgs }: CreatePlanForm) => {
    const { setValue, getValues } = useFormContext();

    const [enableOffice, setEnableOffice] = useState<boolean>(false);
    const [enableFields, setEnableFields] = useState<boolean>(false);
    const [enableMultiFile, setEnableMultiFile] = useState<boolean>(false);
    const [showArgs, updateArgs] = useState<any>({
        customerID: planRequestArgs ? planRequestArgs.customerID : 0,
        officeID: planRequestArgs ? planRequestArgs.officeID : 0,
        projectID: planRequestArgs ? planRequestArgs.projectID : 0,
        unitID: planRequestArgs ? planRequestArgs.unitID : 0,
    });

    useEffect(() => {
        if (getValues('customer') && !isEdit) { setEnableOffice(true) }
    }, [getValues('customer')])

    const handelChangedValue = (type: string, value: any) => {
        if (type === 'customerID') {
            setEnableOffice(value ? true : false)
            setValue('office', null)
        }
        updateArgs((prevState: any) => ({ ...prevState, [type]: value }));
    };

    const changedValues = (type?: string) => {
        setValue('sqFootage', '')
        setValue('volume', '')
        setValue('worstcaseScore', '')
        setValue('windowArea', '')
        if (type !== 'fileList') setValue('associatedPlan', { planID: '', planName: '' })
        setValue('wallHeight', '')
    }

    const handleFileType = (fileTypeID: number) => {
        if (fileTypeID === 3) {
            setEnableFields(true);
            setEnableMultiFile(true);
        }
        else if (fileTypeID === 4 || fileTypeID === 5 || fileTypeID === 6) {
            setEnableFields(false);
            setEnableMultiFile(true);
            changedValues('fileList')
        }
        else {
            setEnableFields(false);
            setEnableMultiFile(false);
            changedValues()
        }
    }

    useEffect(() => {
        if (getValues('planFileTypeID'))
            handleFileType(getValues('planFileTypeID'))
    }, [getValues('planFileTypeID')])

    const handleFileUploadChange = (file: any) => {
        if (!file) {
            setValue('uploadedFile', null);
            setValue('uploadedFileType', null);
        }
        uploadFile(file);
    }

    return (
        <Grid container spacing={2}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <Grid container spacing={2}>
                    {/* <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <FormAutoCompleteSelectDynamic
                            name="customer"
                            label="Customer"
                            disabled={isEdit}
                            onChange={(value: any) => handelChangedValue('customerID', value?.customerID)}
                            getQueryKeyConfig={() => customersApiKeyStore.getCustomers()}
                            optionsValueKey="customerID"
                            optionsLabelKey="customerName"
                        />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <FormAutoCompleteSelectDynamic
                            name="office"
                            label="Office"
                            disabled={isEdit || !enableOffice}
                            watchKeys={['customer']}
                            onChange={(value: any) => handelChangedValue('officeID', value?.officeID)}
                            getQueryKeyConfig={() => officeApiKeyStore.getCustomerOffices(showArgs?.customerID)}
                            optionsValueKey="officeID"
                            optionsLabelKey="officeName"
                        />
                    </Grid> */}
                    <Grid item lg={4} sm={4} xl={4} xs={4}>
                        <FormInput
                            label="Plan (or File) Name"
                            name="planName"
                            maxLength={150}
                        />
                    </Grid>
                    <Grid item lg={4} sm={4} xl={4} xs={4}>
                        <FileUploadTextfield
                            name="uploadedFile"
                            label='File Upload'
                            actionButton={true}
                            fileSizeTooptip
                            validate={extensionArray}
                            onChange={handleFileUploadChange}
                        />
                    </Grid>
                    <Grid item lg={4} sm={4} xl={4} xs={4}>
                        <FormSelectDynamic
                            name="planFileTypeID"
                            label="File Type"
                            onChange={handleFileType}
                            getQueryKeyConfig={() => planApiKeyStore.getPlanFileTypes()}
                            optionsValueKey="planFileTypeID"
                            optionsLabelKeys={['planFileTypeName']}
                        />
                    </Grid>
                </Grid>
            </Grid>
            {(enableFields || enableMultiFile) && (<Grid item lg={12} sm={12} xl={12} xs={12}><Divider /></Grid>)}
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <Grid container spacing={2}>
                    {
                        enableFields && (
                            <>
                                <Grid item lg={3} sm={3} xl={3} xs={3}>
                                    <FormInput
                                        type="number"
                                        label="Area"
                                        name="sqFootage"
                                    />
                                </Grid>
                                <Grid item lg={3} sm={3} xl={3} xs={3}>
                                    <FormInput
                                        type="number"
                                        label="Volume"
                                        name="volume"
                                    />
                                </Grid>
                                <Grid item lg={3} sm={3} xl={3} xs={3}>
                                    <FormInput
                                        type="number"
                                        label="Worst Case Score"
                                        name="worstcaseScore"
                                    />
                                </Grid>
                                <Grid item lg={3} sm={3} xl={3} xs={3}>
                                    <FormInput
                                        type="number"
                                        label="Window Area"
                                        name="windowArea"
                                    />
                                </Grid>
                            </>
                        )
                    }
                    {
                        enableMultiFile && (
                            <Grid item lg={6} sm={6} xl={6} xs={6}>
                                <FormAutoCompleteSelectDynamic
                                    name="associatedPlan"
                                    label="Plan (or File) Name Associated With"
                                    getQueryKeyConfig={() =>
                                        planApiKeyStore.getPlansByUnitAndForAssociation(showArgs.unitID, true)}
                                    optionsValueKey="planID"
                                    optionsLabelKey="planName"
                                />
                            </Grid>
                        )
                    }
                    {
                        enableFields && (
                            <Grid item lg={3} sm={3} xl={3} xs={3}>
                                <FormInput
                                    type="number"
                                    label="Wall Height"
                                    name="wallHeight"
                                />
                            </Grid>
                        )
                    }
                </Grid>
            </Grid>
        </Grid>
    );
}